import { useTheme } from '@emotion/react'

import { ClearScoreMonoLogo, GoodeggsMonoLogo, HalpMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'
import { ClearScoreLogo, GoodeggsLogo, HalpLogo } from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `good-eggs`,
      logo: <GoodeggsMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <GoodeggsLogo />,
      logoName: `GoodEggs`,
    },
    {
      company: `clear-score`,
      logo: <ClearScoreMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <ClearScoreLogo />,
      logoName: `ClearScore`,
    },
    {
      company: `halp`,
      logo: <HalpMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <HalpLogo />,
      logoName: `Halp`,
    },
  ]
}

export { testimonialData }
